var _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCertificatesIco = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 41,
  height: 40,
  fill: "none"
}, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 20.084,
  cy: 20,
  fill: "#FFF09F",
  rx: 20.045,
  ry: 20
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M25.133 9v5.867H31zM16.314 30.089l-1.124-4.507a3.65 3.65 0 0 0 1.144-2.649 3.67 3.67 0 0 0-3.666-3.666A3.67 3.67 0 0 0 9 22.933a3.65 3.65 0 0 0 1.144 2.649l-1.123 4.506c-.07.278.03.571.253.751s.531.21.787.084l2.606-1.304 2.604 1.304a.74.74 0 0 0 .788-.084.74.74 0 0 0 .254-.75m-3.646-4.956c-1.213 0-2.2-.987-2.2-2.2s.987-2.2 2.2-2.2 2.2.987 2.2 2.2-.988 2.2-2.2 2.2"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M25.133 16.333a1.47 1.47 0 0 1-1.466-1.466V9h-8.8c-.808 0-1.467.659-1.467 1.467v7.408c2.482.359 4.4 2.478 4.4 5.058a5.06 5.06 0 0 1-1.003 3.037l.889 3.563h11.847c.81 0 1.467-.657 1.467-1.467V16.333zm-8.066-1.466a.734.734 0 0 1 0-1.467h4.4a.734.734 0 0 1 0 1.467zm10.266 8.8H20a.734.734 0 0 1 0-1.467h7.333a.734.734 0 0 1 0 1.466m0-4.4h-8.8a.734.734 0 0 1 0-1.467h8.8a.734.734 0 0 1 0 1.467"
})));
export default SvgCertificatesIco;